import { createClient } from '@supabase/supabase-js';
import { readConfig } from './config';

const config = readConfig();

function resolveUrl(url: string) {
  return url.startsWith('/') ? `${window.location.origin}${url}` : url;
}

export const supabase = config
  ? createClient(resolveUrl(config.VITE_SUPABASE_URL), config.VITE_SUPABASE_PUBLISHABLE_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;

export const isSupabaseConfigured = Boolean(supabase);
